import styled from "styled-components";

const TopSection = styled.section`
  margin-bottom: 1rem;
`;

export default TopSection;
